type PackagePriceItem = {
  deleted?: boolean;
  is_free_gift?: boolean;
  price?: number | string;
};

const sumPrice = (items: PackagePriceItem[]) =>
  items.reduce((total, item) => total + Number(item.price || 0), 0);

/** ของแถมไม่ถูกนำมาคิดในราคารวมของแพ็กเกจ แต่แยกมูลค่าไว้แสดงต่างหาก */
export const summarizePackagePrice = (list: PackagePriceItem[] = []) => {
  const items = list.filter((item) => !item.deleted);
  const gifts = items.filter((item) => item.is_free_gift);

  return {
    freeGiftCount: gifts.length,
    freeGiftTotal: sumPrice(gifts),
    itemCount: items.length,
    total: sumPrice(items.filter((item) => !item.is_free_gift)),
  };
};
